/*=========================================================================================
  File Name: module-invoicetrial-mutations.js
  Description: InvoiceBotTrial Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBotTrials
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
	updateSizePdf(state, res) {
		state.sizePdf = res;
	}
};
